// import { createStore, combineReducers, compose, applyMiddleware } from 'redux';
// import authReducer from './authReducer';

// const rootReducer = combineReducers({
//     user: authReducer
//   });
import { combineReducers } from "@reduxjs/toolkit";
import authReducer from "./authReducer";
import fileReducer from "./fileReducer";
import subscriptionReducer from "./subscriptionReducer";
import orgReducer from "./orgReducer";
import userReducer from "./userReducer";

const rootReducer = combineReducers({
  auth: authReducer,
  sub: subscriptionReducer,
  org: orgReducer,
  user: userReducer,
  file: fileReducer,
});
export type RootState = any;

export default rootReducer;
